import { ArrayField, Datagrid, TextField, WithRecord } from "react-admin";
import { RecordSummary, MyShow } from "../../ra-lb-tools/components/MyShow";
import { LabeledColumn } from "../../ra-lb-tools/components/labeledColumn";
import { useParams } from "react-router-dom";
import { Row } from "../../ra-lb-tools/components/row";
import { useState } from "react";
import { Box } from "@mui/material";
import get from "lodash/get";
import { MyDateField } from "../../ra-lb-tools/components/myDateField";
import { CurrencyCentsField } from "../../ra-lb-tools/components/currencyField";
import { MyList } from "../../ra-lb-tools/components/myList";
import { Settings } from "../../ra-lb-tools/utils/settings";
import { DebugDotJson } from "../../ra-lb-tools/components/debugDotJson";
import { Debug } from "../../ra-lb-tools/components/debug";
import { StripeLink } from "./stripeLink";
import { MyContextProvider } from "../../ra-lb-tools/components/myContext";
import { AddOneOffInvoiceItemsButton } from "./oneOffItems";

export const OrganizationInvoiceShow = (props) => {
  const paramId = useParams()["id"];
  const id = parseInt(props.id || paramId);

  const [error, setError] = useState(false);
  const onError = (error) => {
    setError(
      "Error: " +
        get(error, "body.detail[0].msg", get(error, "message", "Unknown error"))
    );
  };

  return error ? (
    <Box>{error}</Box>
  ) : (
    <MyContextProvider value={{ permissionsShowAction: "read_invoice" }}>
      <MyShow
        queryOptions={{
          meta: {
            customSegment: "upcoming-invoice",
            transformResponse: (response) => ({
              ...response,
              id,
            }),
          },
          onError,
        }}
        noHeaders={true}
        className="Invoice"
        id={id}
      >
        <RecordSummary className="InvoiceHeader">
          <LabeledColumn>
            <TextField source="customerName" />
            <TextField source="customerEmail" />
          </LabeledColumn>
          <LabeledColumn>
            <TextField source="billingReason" />
            <TextField source="status" />
          </LabeledColumn>
          <LabeledColumn>
            <MyDateField source="periodStart" showTime />
            <MyDateField source="periodEnd" showTime />
          </LabeledColumn>
          <LabeledColumn>
            <MyDateField source="created" showTime />
            <TextField source="currency" />
          </LabeledColumn>
        </RecordSummary>
        <AddOneOffInvoiceItemsButton />
        <Row className="InvoiceDetail">
          <ArrayField source="invoiceItems">
            <Datagrid bulkActionButtons={null}>
              <TextField source="id" />
              <TextField source="description" />
              <TextField source="quantity" />
              <CurrencyCentsField source="amount" />
              {Settings.debugging() && (
                <WithRecord
                  label="__row"
                  render={(record) => (
                    <DebugDotJson data={record} collapsed={true} />
                  )}
                />
              )}
            </Datagrid>
          </ArrayField>
        </Row>
        <Row className="InvoiceTotals">
          <LabeledColumn>
            <CurrencyCentsField source="tax" />
          </LabeledColumn>
          <LabeledColumn>
            <CurrencyCentsField source="subtotalExcludingTax" />
            <CurrencyCentsField source="subtotal" />
          </LabeledColumn>
          <LabeledColumn>
            <CurrencyCentsField source="totalExcludingTax" />
            <CurrencyCentsField source="total" />
          </LabeledColumn>
        </Row>
      </MyShow>
    </MyContextProvider>
  );
};

export const InvoiceList = (props) => {
  const paramId = useParams()["id"];
  const organizationId = parseInt(props.id || paramId);

  return (
    <MyList
      queryOptions={{
        meta: {
          customSegment: `${organizationId}/invoices`,
        },
      }}
      noHeaders={true}
      resource="organizations"
      permissionAction="query_invoices"
      {...props}
    >
      <Box source="id">
        <TextField source="id" />
        <Debug>
          <StripeLink id="id" />
        </Debug>
      </Box>
      <TextField source="customerName" />
      <TextField source="customerEmail" />
      <TextField source="billingReason" />
      <TextField source="status" />
      <MyDateField source="periodStart" showTime />
      <MyDateField source="periodEnd" showTime />
      <MyDateField source="created" showTime />
      <TextField source="currency" />
      <CurrencyCentsField source="tax" />
      <CurrencyCentsField source="subtotalExcludingTax" />
      <CurrencyCentsField source="subtotal" />
      <CurrencyCentsField source="totalExcludingTax" />
      <CurrencyCentsField source="total" />
    </MyList>
  );
};
